import { Component, inject, OnInit } from '@angular/core';
import { first } from 'rxjs';

import { UserService } from '@services/api/user/user.service';
import { TenantService } from '@services/api/tenant/tenant.service';
import { TenantDataService } from '@services/data/tenant-data.service';
import {
    SelectComponent,
    SelectionChangeEvent,
} from '@shared/select/select.component';
import { HasRoleDirective } from '@directives/has-role.directive';
import { SelectOption } from '@models/shared.model';
import { Role } from '@models/user';
import { Tenant } from '@models/tenant';
import DATA_QA from '@automation/data-qa.json';

@Component({
    selector: 'app-tenant-selection',
    templateUrl: 'tenant-selection.component.html',
    styleUrl: 'tenant-selection.component.scss',
    imports: [SelectComponent, HasRoleDirective],
})
export class TenantSelectionComponent implements OnInit {
    protected tenantOptions: SelectOption[] = [];
    protected readonly Role = Role;
    protected readonly dataQa = DATA_QA;

    private tenants: Tenant[] = [];

    private readonly userService = inject(UserService);
    private readonly tenantService = inject(TenantService);
    readonly tenantDataService = inject(TenantDataService);

    get currentTenant() {
        return this.tenantDataService.currentTenantId;
    }

    ngOnInit(): void {
        this.getTenants();
    }

    onTenantSelect(event: SelectionChangeEvent) {
        const tenantId: number = event.value;
        const selectedTenant: Tenant = this.tenants.find(
            (tenant) => tenant.id === tenantId,
        )!;
        this.tenantDataService.updateCurrentTenant(selectedTenant);
        this.associateTenantWithUser(selectedTenant.id);
    }

    private associateTenantWithUser(tenantId: number) {
        this.userService
            .associateTenant({ tenantId })
            .pipe(first())
            .subscribe();
    }

    private getTenants() {
        this.tenantService
            .getTenants()
            .pipe(first())
            .subscribe({
                next: (tenants) => {
                    this.tenants = tenants;
                    this.tenantOptions = tenants.map((tenant) => ({
                        value: tenant.id,
                        viewValue: tenant.name,
                    }));
                },
            });
    }
}
